import React from 'react';
import icons from './svg.svg?url';

const Icon = (props) => {
  const { iconName, onClick, name, ...restProps } = props;

  return (
    <svg role='img' className={`icon icon-${iconName}`} onClick={onClick} name={name} {...restProps}>
      <use xlinkHref={`${icons}#${iconName}`} />
    </svg>
  );
};

export default Icon;
